import { motion } from "framer-motion";

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

const CHAPTERS = [
  {
    num: "01",
    title: "La pasada",
    body: "La línea paralela repetida, a intervalo constante, con su traslape declarado. Cada vuelo es una retícula sobre el lote: nada se solapa, nada queda sin cubrir.",
    meta: "INTERVALO FIJO · TRASLAPE 30%",
  },
  {
    num: "02",
    title: "La cota",
    body: "Altura de vuelo baja y constante. La gota sale calibrada del tanque y llega donde debe llegar: a la hoja, no al aire.",
    meta: "ALTURA CONTROLADA · GOTA AJUSTADA",
  },
  {
    num: "03",
    title: "La deriva",
    body: "La deriva es lo que se escapa. No la eliminamos prometiendo: la medimos, la documentamos y la reducimos vuelo a vuelo.",
    meta: "VIENTO MEDIDO · FRANJAS PROTEGIDAS",
  },
];

const Manifesto = () => (
  <section id="manifiesto" data-testid="manifesto-section" className="relative bg-[#151A1F] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6 sm:px-10">
      <motion.p
        {...reveal}
        className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#00A651]"
      >
        Manifiesto operativo — Deriva Calibrada
      </motion.p>
      <motion.h2
        {...reveal}
        transition={{ ...reveal.transition, delay: 0.1 }}
        className="font-display font-bold tracking-tight leading-[1.08] text-2xl sm:text-4xl lg:text-5xl mt-6 max-w-3xl"
      >
        La belleza no está en el control absoluto, sino en la precisión con que se mide lo que no se controla.
      </motion.h2>

      <div className="mt-16 sm:mt-24 grid grid-cols-1 md:grid-cols-3 border-t border-l border-white/10">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.num}
            data-testid={`manifesto-chapter-${c.num}`}
            {...reveal}
            transition={{ ...reveal.transition, delay: i * 0.15 }}
            className="group relative border-b border-r border-white/10 p-8 sm:p-10 hover:bg-white/[0.03] transition-colors duration-500"
          >
            <span className="font-display font-bold text-6xl sm:text-7xl text-[#00A651]/15 group-hover:text-[#00A651]/30 transition-colors duration-500 tabular">
              {c.num}
            </span>
            <h3 className="font-display font-semibold text-xl sm:text-2xl mt-6 tracking-tight">{c.title}</h3>
            <p className="mt-4 text-sm sm:text-base text-[#F6F7F5]/65 leading-relaxed">{c.body}</p>
            <p className="mt-8 font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#F6F7F5]/40">
              {c.meta}
            </p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
